import {wpautop} from './wpautop'
import ReactHtmlParser from 'react-html-parser'

export const breakpoints = {
	small: 0,
	medium: 640,
	large: 1024,
	xlarge: 1200,
	xxlarge: 1440,
}

export function getVideo(youtubeid, vimeoid, ownfile) {
    if (youtubeid) {
    	return 'https://www.youtube.com/watch?v='+youtubeid
    }
    else if (vimeoid) {
    	return 'https://vimeo.com/'+vimeoid
    }
    else if (ownfile) {
    	return ownfile
    }
    else {
    	return ''
    }
}

export function setHTML(string) {
	// let newString = ''
	// string && string.split(/\n\s*\n/).map( (item) => 
	//     newString += ( item !== '' && item.indexOf('<p>') === -1 && !item.startsWith('<ul') && !item.startsWith('<ol') ) ? '<p>' + item + '</p>' : item
	// )
	// return { __html: newString }
    return string ? ReactHtmlParser(wpautop(string)) : ''
}


// WEBPACK FOOTER //
// ./src/helpers/helpers.js